import Vue from "vue";
import Vuex from "vuex";
import { vuexOidcCreateStoreModule } from "vuex-oidc";
import { oidcSettings } from "@/plugins/oidc";
import { axiosSingleton } from "../plugins/axios";
import { GetPerfilesByIdServicio, getConvocatoriaActiva } from "@/api";
import createPersistedState from "vuex-persistedstate";

// region [ rgba (10,100,10,0.3) ] Modulos
import permisos from "./modules/permisos";

import snackbar from "./modules/snackbar";
// endregion

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    oidc: vuexOidcCreateStoreModule(
      oidcSettings,
      {
        namespaced: true,
        dispatchEventsOnWindow: true,
      },
      {
        userLoaded(user) {
          //console.log(user);
          axiosSingleton.getInstance().defaults.headers.common[
            "Authorization"
          ] = `Bearer ${user.id_token}`;
        },
      }
    ),

    permiso: permisos,

    snackbar,
  },
  plugins: [
    createPersistedState({
      paths: [
        "permisos",
        "permisosLoaded",
        "permiso",
        "menuList",
        "objConvocatoriaActiva",
      ],
    }),
  ],
  state: {
    categorias: [],
    listaMenu: [],
    empleadoDatos: {
      foto: {
        grande: "",
      },
    },
    permisos: [],
    perfil: {},
    permisosLoaded: false,
    empleadoDatosLoaded: false,
    idEmpleado: "",
    // Menu Izquierdo ---<
    menuList: [
      // {
      //   ruta: "/",
      //   icon: "mdi-calendar",
      //   nombre: "Principal"
      // },
      // {
      //   ruta: "/rutaAlterna",
      //   icon: "mdi-account-multiple",
      //   nombre: "Ruta 1"
      // },
      // {
      //   ruta: "/rutaAlterna2",
      //   icon: "mdi-school",
      //   nombre: "Ruta 2"
      // }
    ],
    // --->

    // Menu menuDespegable ---<
    msize: "800px",
    mactivo: true,
    menuDespegable: [
      {
        nombre: "Datos",
        icon: "mdi-account-box",
      },
      {
        nombre: "Domicilio",
        icon: "mdi-map-marker",
      },
      {
        nombre: "Formación",
        icon: "mdi-school",
      },
      // {
      //   nombre: "Panel4",
      //   icon: "mdi-human-male-female"
      // },
      // {
      //   nombre: "Panel5",
      //   icon: "mdi-chart-line"
      // },
      // {
      //   nombre: "Panel6",
      //   icon: "mdi-folder-multiple"
      // }
    ],
    panelSel: 0,
    objConvocatoriaActiva: {},
    // --->

    // categorias: []
  },
  mutations: {
    setCategorias(state, payload) {
      state.categorias = payload;
    },
    setEmpleado(state, data) {
      state.empleadoDatos = data;
    },
    setListaMenu(state, data) {
      state.menuList = data;
    },
    setPanel(state, x) {
      state.panelSel = x;
    },
    setPanelDesp(state, x) {
      state.mactivo = x;
    },
    setPerfil(state, x) {
      state.perfil = x;
    },
    setPermisos(state, x) {
      state.permisos = x;
    },
    setPermisosLoaded(state, x) {
      state.permisosLoaded = x;
    },
    setObjConvocatoriaActiva(state, x) {
      state.objConvocatoriaActiva = x;
    },
    setEmpleadoDatosLoaded(state, x) {
      state.empleadoDatosLoaded = x;
    },
  },
  actions: {
    async obtenerEmpleado({ state }) {
      // console.log('obtenerEmpleado', state.oidc.id_token)

      await axiosSingleton
        .getInstance()
        .get(`https://enjambrec.ugto.mx/DSI/perfil?cliente=CEPIUG`, {})
        .then((res) => {
          res.data.role = JSON.parse(res.data.role);
          this.commit("setEmpleado", res.data);
          //console.log(state.empleadoDatos);
          this.commit("setEmpleadoDatosLoaded", true);
        })
        // .then(res => console.log("empleado", res.data))
        .catch((error) => console.log(error));
      //console.log('this.state.oidc', this.state.oidc);
    },
    async obtenerListaMenu() {
      var lst = [];

      lst.push({
        ruta: "/",
        icon: "mdi-home",
        nombre: "Inicio",
      });

      if (
        this.state.empleadoDatos.Id_Empleado != "" &&
        this.state.empleadoDatos.Id_Empleado != undefined
      ) {
        lst.push({
          ruta: "/Investigador/Bandeja",
          icon: "mdi-format-list-numbered",
          nombre: "Bandeja Protocolos Proyectos",
        });
      }

      if (
        this.state.empleadoDatos.role.filter((n) => n == "Revisión").length > 0
      ) {
        lst.push({
          ruta: "/RevisionProtocolosProyectos/Bandeja",
          icon: "mdi-format-list-checks",
          nombre: "Bandeja Revisión Protocolos Proyectos",
        });
      }

      if (
        this.state.empleadoDatos.role.filter(
          (n) => n == "Evaluación: Observaciones Individuales"
        ).length > 0 ||
        this.state.empleadoDatos.role.filter(
          (n) => n == "Evaluación: Observaciones Principales"
        ).length > 0
      ) {
        lst.push({
          ruta: "/EvaluacionProtocolosProyectos/Bandeja",
          icon: "mdi-playlist-check",
          nombre: "Bandeja Evaluación Protocolos Proyectos",
        });
      }

      if (
        this.state.empleadoDatos.role.filter(
          (n) => n == "Administrador periodos"
        ).length > 0
      ) {
        lst.push({
          ruta: "/BandejaPeriodos",
          icon: "mdi-calendar-outline",
          nombre: "Administrar Periodos",
        });
      }

      if (
        this.state.empleadoDatos.role.filter(
          (n) => n == "Bandeja envío correos"
        ).length > 0
      ) {
        lst.push({
          ruta: "/BandejaEnvioCorreos",
          icon: "mdi-email-outline",
          nombre: "Bandeja Envío Correos",
        });
      }

      this.commit("setListaMenu", lst);
    },
    async cargarPermisosServicio({ commit, dispatch }) {
      var self = this;

      // Obtener permisos
      try {
        /* let res = await GetPerfilesByIdServicio(254);

        if (res.status === 200) {
          if (res.data.flag === true) {
            if (res.data.message === "True") { */
        this.commit("setPermisosLoaded", true);

        //if (res.data.data[0] != undefined) {
        //var tmpPerf = res.data.data[0];
        /* tmpPerf.idDivisionCat = dispatch(
                  "getIdDivisionCat",
                  tmpPerf.idDivision
                ); */

        //tmpPerf.idDivision = parseInt(tmpPerf.idDivision);

        //this.commit("setPerfil", tmpPerf);
        //this.commit("setPermisos", res.data.data[0].lstPermisos);

        await dispatch("obtenerListaMenu");
        await dispatch("cargarConvocatoriaActiva");
        /* } else {
                dispatch("eliminarPermisosServicioState");
              }

              await dispatch("cargarConvocatoriaActiva");
            } else {
              dispatch("eliminarPermisosServicioState");
            }
          } else {
            dispatch("eliminarPermisosServicioState");
          }
        } else {
          dispatch("eliminarPermisosServicioState");
        } */
      } catch (e) {
        console.log("error:");
        console.log(e);
        dispatch("eliminarPermisosServicioState");
      }
    },
    async eliminarPermisosServicioState({ commit, dispatch }) {
      this.commit("setPermisosLoaded", false);

      this.commit("setPerfil", {});
      this.commit("setPermisos", []);

      await dispatch("obtenerListaMenu");
    },
    async tienePermisoServicio({ commit, dispatch }, data) {
      var self = this;
      var valido = false;

      /* if (!this.state.permisosLoaded || data.forzar == true) {
        await dispatch("cargarPermisosServicio");
      } */

      if (
        this.state.empleadoDatos.role.filter((n) => n == data.permiso).length >
        0
      ) {
        valido = true;
      }

      return valido;
    },
    async cargarConvocatoriaActiva({ commit, dispatch }) {
      var self = this;

      // Obtener permisos
      try {
        let res = await getConvocatoriaActiva();

        if (res.status === 200) {
          if (res.data.flag === true) {
            if (res.data.message === "Consulta correcta") {
              this.commit("setObjConvocatoriaActiva", res.data.data);
            } else {
              dispatch("asignarValoresDefaultConvocatoriaActiva");
            }
          } else {
            dispatch("asignarValoresDefaultConvocatoriaActiva");
          }
        } else {
          dispatch("asignarValoresDefaultConvocatoriaActiva");
        }
      } catch (e) {
        console.log("error:");
        console.log(e);
        dispatch("asignarValoresDefaultConvocatoriaActiva");
      }
    },
    async asignarValoresDefaultConvocatoriaActiva({ commit, dispatch }) {
      this.commit("setObjConvocatoriaActiva", {
        idConvocatoria: 0,
        registro: false,
        revision: false,
        respuesta: false,
      });
    },
  },
});
